import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DataTableDirective } from "angular-datatables";
import { title } from "process";
import { Subject } from "rxjs";
import { CookieService } from "src/app/core/services/cookie.service";
import { GeneralService } from "src/app/Service/general.service";
import Swal from "sweetalert2";

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: "app-view-tp-list",
  templateUrl: "./view-tp-list.component.html",
  styleUrls: ["./view-tp-list.component.scss"],
})
export class ViewTpListComponent implements OnInit {
  breadCrumbItems: Array<{}>;
  isdropdownShow: boolean;
  isLoading: boolean;

  dtOptions: DataTables.Settings = {};
  dtOptions1: DataTables.Settings = {};
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtTrigger = new Subject<any>();
  submitted = false;
  user: any;
  currentUser: any;
  UserID: any;
  Status: any;
  Service_Sub_Type_ID: any;
  planId: any;

  constructor(
    private datepipe: DatePipe,
    private gs: GeneralService,
    private router: Router,
    private renderer: Renderer2,
    private http: HttpClient,
    private route: ActivatedRoute,
    private cookie: CookieService
  ) {
    let a = this.router.getCurrentNavigation().extras;
    if (a) {
      if (a.state) {
        this.UserID = a.state.id;
        this.Status = a.state.Status;
        this.planId = a.state["PlanId"];
        localStorage.setItem("Status", this.Status);
        console.log("thisuserid", this.UserID);
        localStorage.setItem("id", this.UserID);
        localStorage.setItem("PlanID", this.planId);
      }
    }
    if (localStorage.getItem("Status")) {
      this.Status = localStorage.getItem("Status");
    }
    if (localStorage.getItem("id")) {
      this.UserID = localStorage.getItem("id");
    }
    // console.log("UserID",this.UserID)
    this.breadCrumbItems = [
      { label: "User Details", path: "/users/users-users-details" },
      { label: "TP List", path: "/", active: true },
    ];
  }

  ngOnInit() {
    this.getusersbyid();
    this.currentUser = JSON.parse(this.cookie.getCookie("currentUser"));
    this.dtOptions = {
      pagingType: "simple_numbers",
      pageLength: 10,
      processing: true,
      serverSide: true,
      // ordering: true,
      searching: true,
      order: [[0, "desc"]],
      ajax: (dataTablesParameters: any, callback) => {
        this.http
          .get<DataTablesResponse>(
            // `${this.gs.getLawyer()}/${dataTablesParameters.search.value != '' ? dataTablesParameters.search.value + '/' : ''}${((dataTablesParameters.start + dataTablesParameters.length) / dataTablesParameters.length)}/${dataTablesParameters.length}`,

            `${this.gs.getTPlist()}` +
              `${this.UserID}` +
              `${
                dataTablesParameters.length.value != ""
                  ? "?PageSize=" + dataTablesParameters.length
                  : ""
              }` +
              `&PageNo=${
                (dataTablesParameters.start + dataTablesParameters.length) /
                dataTablesParameters.length
              }` +
              `${
                dataTablesParameters.search.value != ""
                  ? "&SearchKey=" + dataTablesParameters.search.value
                  : ""
              }`
          )
          .subscribe((resp: any) => {
            callback({
              recordsTotal: resp.TotalCount,
              recordsFiltered: resp.TotalCount,
              data: resp.data,
            });
          });
      },
      columns: [
        {
          title: "Id",
          data: null,
          render: (data) => {
            return data.UserSubscriptionMainID;
          },
        },
        {
          title: "Entry_Date",
          data: null,
          render: (data) => {
            if (data.entry_date === "0000-00-00" || data.entry_date == null) {
              return "--";
            } else {
              return this.datepipe.transform(data.entry_date, "yyyy-MM-dd");
            }
          },
        },
        {
          title: "District",
          data: null,
          render: (data) => {
            return data.DistrictName ? data.DistrictName : "--";
          },
        },
        {
          title: "Taluka",
          data: null,
          render: (data) => {
            return data.TalukaName ? data.TalukaName : "--";
          },
        },
        {
          title: "Village",
          data: null,
          render: (data) => {
            return data.VillageName ? data.VillageName : "--";
          },
        },
        {
          title: "TPNo",
          data: null,
          render: (data) => {
            return data.TPNo ? data.TPNo : "--";
          },
        },
        {
          title: "Service Name",
          data: null,
          render: (data) => {
            return data.SubType_Name ? data.SubType_Name : "--";
          },
        },
        {
          title: "Service Type",
          data: null,
          render: (data) => {
            // this.Service_Sub_Type_ID = data.Service_Sub_Type_ID
            if (
              Number(data.Service_Sub_Type_ID) >= 24 &&
              Number(data.Service_Sub_Type_ID) <= 27
            ) {
              return "Existing TP";
            }
            return "Upcoming TP";
          },
        },
        {
          title: "Start Date",
          data: null,
          render: (data) => {
            return this.datepipe.transform(data.startDate, "MMM, dd yyyy");
          },
        },
        {
          title: "End Date",
          data: null,
          render: (data) => {
            return this.datepipe.transform(data.endDate, "MMM, dd yyyy");
          },
        },
        {
          title: "Status",
          data: null,
          render: (data) => {
            if (data.isActive == "1") return `Active`;
            else return `In Active`;
          },
        },
        {
          title: "Action",
          data: null,
          render(data) {
            if (data.isActive == "1") {
              return `<div style="display:flex"><a title="Edit This Service" class="edit">
               <i class="m-2 font-18 mdi mdi-content-save-edit-outline text-secondary" editTpID="${data.UserSubscriptionMainID}"></i></a>
              <a title="InActivate This Service" class="delete" >
                  <i
                    class="m-2 font-18 mdi mdi-cancel text-secondary"
                    updateTpID="${data.UserSubscriptionMainID}" isActive="${data.isActive}"
                  ></i>
                </a></div>
              `;
            } else {
              return `<div style="display:flex"><a title="Edit This Service" class="edit">
              <i class=" font-18 mdi mdi-content-save-edit-outline text-secondary" editTpID="${data.UserSubscriptionMainID}"></i></a></div>`;
            }
          },
        },
      ],
      drawCallback: () => {
        $(".edit").on("click", (e) => {
          this.router.navigate(["/users/tp-service"], {
            state: {
              id: e.target.getAttribute("editTpID"),
              EditTP: true,
              Userid: this.UserID,
            },
          });
          console.log(
            "UserSubscriptionMainID",
            e.target.getAttribute("editTpID")
          );
        });
        $(".delete").on("click", (e) => {
          var msg;
          var value;
          if (e.target.getAttribute("isActive") == "1") {
            msg = "You want Deactivate this TP ?";
            value = "0";
          } else {
            msg = "You want Activate this TP ?";
            value = "1";
          }
          Swal.fire({
            title: "Are you sure?",
            text: msg,
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            confirmButtonClass: "btn btn-danger mt-2",
            cancelButtonClass: "btn btn-success ml-2 mt-2",
            buttonsStyling: false,
          }).then((result) => {
            if (result.value) {
              this.isLoading = true;
              const data = {
                UserSubscriptionMainID: e.target.getAttribute("updateTpID"),
                isActive: value,
                // "UserID" : this.UserID
              };
              this.gs.isDeactivate(data).subscribe(
                (data: any) => {
                  this.isLoading = false;
                  this.rerender();
                  if (data.status === 200) {
                    this.submitted = false;
                    Swal.fire({
                      title: "TP Deactivated",
                      text: data.Message,
                      type: "success",
                      timer: 1500,
                    }).then(() => {
                      this.submitted = false;
                      // this.reFresh.emit();
                    });
                  } else {
                    Swal.fire({
                      // title: data.error_code,
                      text: data.Message,
                      type: "info",
                      timer: 1500,
                    });
                  }
                },
                (error) => {
                  //Error callback
                  this.isLoading = false;
                  Swal.fire({
                    title: error.status,
                    text: "Internal Server Error",
                    type: "error",
                  });
                }
              );
              return false;
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              return false;
            }
          });
        });
        $(".update").on("click", (e) => {
          var msg;
          var value;
          if (e.target.getAttribute("isActive") == "1") {
            msg = "You want Deactivate this TP ?";
            value = "0";
          } else {
            msg = "You want Activate this TP ?";
            value = "1";
          }
          Swal.fire({
            title: "Are you sure?",
            text: msg,
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            confirmButtonClass: "btn btn-danger mt-2",
            cancelButtonClass: "btn btn-success ml-2 mt-2",
            buttonsStyling: false,
          }).then((result) => {
            if (result.value) {
              this.isLoading = true;
              const data = {
                UserSubscriptionMainID: e.target.getAttribute("updateTpID"),
                isActive: value,
                UserID: this.UserID,
                Service_Sub_Type_ID: e.target.getAttribute("data"),
              };
              this.gs.isActive(data).subscribe(
                (res: any) => {
                  if (res.status === 400) {
                    Swal.fire({
                      // title: title,
                      text: res.Message,
                      type: "info",
                      timer: 1500,
                    });
                  } else {
                    this.submitted = false;
                    Swal.fire({
                      // title: title,
                      text: res.message,
                      type: "success",
                    }).then(() => {
                      this.submitted = false;
                      // this.reFresh.emit();
                    });
                  }
                  if (data.isActive == "1") {
                    var Title = "TP Activated";
                  } else {
                    var Title = "TP Dectivated";
                  }
                  this.rerender();
                  this.isLoading = false;
                },
                (error) => {
                  //Error callback
                  this.isLoading = false;
                  Swal.fire({
                    title: error.status,
                    text: "Internal Server Error",
                    type: "error",
                  });
                }
              );
              return false;
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              return false;
            }
          });
        });
      },
    };
  }
  getusersbyid() {
    this.isLoading = true;
    this.gs.getusersbyid(this.UserID).subscribe(
      (res: any) => {
        this.isLoading = false;
        this.user = res.data[0];
        this.user.mobileno = this.user.MobileNo.split(",");
        this.user.email = this.user.EmailID.split(",");
        localStorage.setItem("PlanId", this.planId);
      },
      (error) => {
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
      }
    );
  }
  ngAfterViewInit() {
    this.dtTrigger.next();
  }
  ShowMessage() {
    return this.Status === "deactivated";
  }
  AddTP() {
    this.router.navigate(["/users/tp-service"], {
      state: { Uid: this.UserID, EditTP: false },
    });
  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }
}
